/* eslint-disable import/first */
import React from 'react'
import videojs from 'video.js';
window.videojs = videojs;
import "videojs-contrib-ads";
import '@videojs/http-streaming';
require('./ima/videojs.ima.js')
import 'video.js/dist/video-js.css'
import './lib/videojs.ima.css'
import {get, some, extend, each, includes, assignIn, filter, round, isFunction, map, find, isEmpty} from 'lodash'
import Cookies from 'js-cookie'
import { getVideo, getVideoSignature, getVideoEmbed } from '~/redux/video/helpers'
import { saveWatchHistory } from '~/redux/uservideo/helpers'
import VideoJSBeacon from '~/tools/analytics/beacon/video'
import extract from "~/tools/extractDomain";
import getEnvironment from '~/tools/userEnvironment/codeEnvironment'
import browser from '~/tools/userEnvironment/browser'
import Embed from './screens/Embed'
import Upgrade from './screens/upgrade'
import RatingDiscretion from './screens/rating'
import NextVideoTimer from './screens/nextVideoTimer'
import { trackEvent, getPlaySourcePrefix } from '~/tools/analytics/cleverTap'
import connect from '~/tools/connect'
import userStore from '~/redux/user/store'
import {getDRMWidevinePlayreadyObject,getFairPlayObject} from './drmObject'
import PinOverlay from '~/views/Popup/views/PinOverlay'
import { isPinSet } from '~/tools/isPinSet'
import { getRatingList } from '~/modules/User/ParentalControls/ratingMap'
import EmbedWall from './screens/embedWall'
import { persolizationSetUpProfile } from '~/views/Popup/popup'
import { getLocalizedVal } from '~/tools/localization/helpers';
import WaysToWatch from './screens/waysToWatch'
import {getInvisiblePlansById} from "~/redux/user/subscription"
import {checkVideoContentEntitlement} from "~/tools/checkSeries"
import { refreshTve } from '~/redux/user/actions'
import { configKeyShortcuts } from "./configKeyShortcuts";

class VideoJS extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      video: null,
      startedAtSetTime: false,
      ratingDisplayDone: !this.isRatingEnabled(),
      showRatingDiscretion: false,
      videoWall: false,
      videoEnded: false,
      showEmbed: false,
      askPin : true,
      showPinOverlay: props.showPinOverlay || false,
      showUpgrade:false,
      embedPlayable:false
    }
    // used to skip corrupt hls streams at the video start
    this.bufferedPercent = 0
    this.playStarted = false
    this.lastBufferedTime = 0
    this.totalBufferTime = 0
    this.bufferCount = 0
    this.errorMessage = null
    this.streamedData = []
    this.triggeredPause = false;
    this.isFromErrorEvent=false;
    this.ratingMap = []
    this.initialData = {}
    this.sourceURL = null;
    this.resetHistory = false
    this.toggleRatingDiscretion = this.toggleRatingDiscretion.bind(this)
    this.toggleEmbed = this.toggleEmbed.bind(this)
    this.dimensions = window.innerWidth <= 600 ? { height: 203, width: 360 } : { height: 480, width: 854 }
    this.showUpgradePopup = this.showUpgradePopup.bind(this)
    this.handlePreviewSettings()

    if (props.video && props.video.tags) {
      this.tags = props.video.tags.map(t => t && t.title).join(',')
    }

    if (props.video && props.video.categories) {
      this.categories = props.video.categories.map(c => c && c.title).join(',')
    }
    this.hardWallEnabled = get(window.settings, 'forceLogin')
  }

  handlePreviewSettings() {
    const previewSettings = get(window.settings, 'features.free_preview')
    if (!previewSettings)
      return

    const showPreview = previewSettings.isFreePreview
    this.previewshowUnit = previewSettings.length.unit
    const previewShowTime =
      (this.previewshowUnit === "Minutes")
        ? parseFloat(previewSettings.length.multiplier) * 60
        : parseFloat(previewSettings.length.multiplier)
    this.previewTime = showPreview && previewShowTime
    this.perVideo = showPreview && previewSettings.per_video
  }

  async componentWillReceiveProps(nextProps, prevState) {
    let curVideoId = this.props.video && (this.props.video.id || this.props.video.gist.id);
    let prevVideoId = nextProps.video && (nextProps.video.id || nextProps.video.gist.id);

    if(curVideoId === prevVideoId)
      return

    if(nextProps.isEpisode && !this.previewTime && !nextProps.isEntitled){
      this.player && this.player.reset()
      this.setState({ videoWall: true, plans:[], video: nextProps.video, videoEnded: false,})
      return
    }

    const { video } = nextProps
    let videoFreePlan = null
    if(nextProps.isEpisode && !this.previewTime && !nextProps.isEntitled){
      this.setState({ videoWall: true })
      return
    }
    if(!this.state.user){
      if(nextProps.isEpisode){
        const episodePlans = video && video.episodePlans
        videoFreePlan = episodePlans && find(episodePlans, function(o){return o.monetizationModel === 'FREE'})
      }else{
        const videoPlans = video && video.plans
        const videoHasFreePlan = videoPlans && find(videoPlans, function(o){return o.type === 'FREE'})
        const videoFreePlanId = videoHasFreePlan && videoHasFreePlan.planIds && videoHasFreePlan.planIds[0]
        const freePlanDetails = videoFreePlanId && await getInvisiblePlansById(videoFreePlanId)
        videoFreePlan = freePlanDetails && freePlanDetails[0]
      }
  
      if(videoFreePlan){
        let {isEmailRequired, isLoginRequired} = videoFreePlan.featureSetting
        const emailProcessed = localStorage.getItem('emailProcessed')
        if((!this.state.user && isLoginRequired) || (!emailProcessed && isEmailRequired)){
          if(nextProps.updateEntitlementScreen && isLoginRequired){
            nextProps.updateEntitlementScreen([{...videoFreePlan}])
          }
          this.setState({
            videoWall: true,
            plans: [{...videoFreePlan}]
          })
          return
        }
    }
    }

    if(nextProps.video){
      const { video: { currentEpisode, currentSeason, showData: { seasons } = {} } } = nextProps
      const episode = (seasons && seasons[currentSeason].episodes[currentEpisode]) || {}
    }
    
    if(this.player && this.player.textTracks() && this.player.textTracks().tracks_ && this.player.textTracks().tracks_.length>0){
      this.currentModeValue = this.player.textTracks().tracks_.find((element, position)=>{
        if(localStorage.getItem('ccDefault') === 'on' && localStorage.getItem('ccDefaultLang') === element.label){
          return element;
        } else {
          return null;
        }
      })
    }
    if (this.props.user === null) {
      this.setState({ videoWall: false })
      // this.player.play()
    }
    
    if (nextProps && (nextProps.isEpisode || nextProps.isPlaylistItem) && curVideoId !== prevVideoId) {
      this.player && this.player.reset()
      this.setState({ video: nextProps.video, videoEnded: false, plans:[], videoWall:false })

      // check entitlement
      //const isHls = this.props.fileType === 'hls'
      const videoAssets = await this.fetchVideoSources((nextProps.video.gist.originalObjectId || nextProps.video.gist.id),  nextProps.showPinOverlay, nextProps); 

      if(!videoAssets) return

      const src = videoAssets && videoAssets.src;

      this.playStarted = false
      this.streamedData = []
      if(this.interval) clearInterval(this.interval)
    
      // reset player to prevent firefox from crashing
      this.player.reset()

      //Check for Autoplay for DRM Videos.
      if(this.isDrmEnabledVideo){
        this.configureDRMPlayback(videoAssets)
      }else{
        this.player.src(src)      
        this.player.load()
        this.player.play()
      }
      //Commented this condition as resolution control is working fine without it.
      // update resolution control on mp4
      // if (!isHls && this.player.tech_.options_.source) {
      //   this.player.tech_.options_.source.src = src
      //   this.addResolutionControl(this.player, nextProps.fileType, videoAssets, this.state.isLiveStream)
      // }

       // update title on news video player
       if(nextProps.customSkin === "./newsSkin"){
        import("./newsSkin").then(({updateVideoTitle,}) => {
          updateVideoTitle && updateVideoTitle(this.player, get(nextProps, 'video.gist'));
        });
      }
    }
    
    if(this.props.video && nextProps.video && !this.props.video.seasons && nextProps.video.seasons){
      // update title on news video player
      if(nextProps.customSkin === "./newsSkin"){
        import("./newsSkin").then(({updateSeasonList,}) => {
          updateSeasonList && updateSeasonList(this.player, nextProps.video);
        });
      }
    }
  }

  getSignature() {
    return this.props.fileType === 'mp4'
      ? Promise.resolve()
      : getVideoSignature(this.props.videoId)
  }

  showPinOverlay = async () => {
    if(this.props.showPinOverlay === undefined) {
      let showPinOverlay = false;
      let userRating = this.props.user && this.props.user.parentalControl && this.props.user.parentalControl.parentalRating
      let videoRating = this.props.video && this.props.video.parentalRating
      if(userRating && !this.state.showPinOverlay && typeof(userRating) == "string") {   
        let filteredRating
        if(this.ratingMap.length) {  
          filteredRating = this.ratingMap && this.ratingMap.find(x => x.key === userRating)   
        } else {  
          await getRatingList()
          .then(rating_map => {    
            this.ratingMap = rating_map
            filteredRating = rating_map && rating_map.find(x => x.key === userRating)    
          })
          .catch((e) => {
            this.setState({showPinOverlay : false})
          })
        }
        if(filteredRating && filteredRating.value) {
          showPinOverlay = (filteredRating.value).includes(videoRating);
          this.setState({showPinOverlay : showPinOverlay})
        }  
      }
    } 
  }

  fetchVideoSources(id, showPinOverlay,nextProps) {
    var ref = this;
    if(showPinOverlay && isPinSet() && this.state.askPin) {
      this.setState({initializePlayer: true, currentVideoId: id})
      return Promise.resolve({ src: "", type: 'video/mp4' })
    }
    if (this.props && this.props.src) return Promise.resolve({ src: this.props.src, type: 'video/mp4' })
    if (!id) return Promise.reject('No Video Src or Video ID Not found')
    let isEmbed = this.props.embed === undefined ? false : this.props.embed;
    return getVideoEmbed(id, isEmbed, response => {
      if(nextProps) {
        ref.resetHistory = false
        ref.initialData = {}
        this.addBeaconObject(nextProps)
      }
      this.errorMessage = null
      const domain = extract(window.location.hostname)
      const expiresIn = new Date(new Date().getTime() + response.data.expireTime * 1000);
      Cookies.set(
        "CloudFront-Key-Pair-Id",
        response.data["CloudFront-Key-Pair-Id"],
        { domain: `.${domain}`, expires: expiresIn }
      );
      Cookies.set(
        "CloudFront-Policy",
        response.data["CloudFront-Policy"],
        { domain: `.${domain}`, expires: expiresIn }
      );
      Cookies.set(
        "CloudFront-Signature",
        response.data["CloudFront-Signature"],
        { domain: `.${domain}`, expires: expiresIn }
      );
      
      var streamingInfo = response.data.video.streamingInfo
      this.assets = streamingInfo.videoAssets
      const widthOfDevice = (window.innerWidth * 66.66) / 100
      const impolicy = `?impolicy=resize&w=${widthOfDevice}&h=${widthOfDevice * 0.5625}`
      let videoTag = response.data.ads && get(response.data.ads, 'preRoll.adTags.web.active') && get(response.data.ads, 'preRoll.adTags.web.url')
      let adPlanFeatures = response.data.ads && response.data.ads.features
      this.setState({
        isLiveStream: streamingInfo.isLiveStream,
        isFree: this.props.isFree || get(response, 'data.video.gist.free'),
        video: get(response, 'data.video'),
        gist: get(response, 'data.video.gist'),
        poster: `${response.data.video.gist.videoImageUrl}${impolicy}`,
        plans: get(response, 'data.plans'),
        dfpTag: videoTag || null,
        adFeatures:adPlanFeatures || {}
      })
      if (this.previewshowUnit === 'Videos' && !this.state.isFree) {
        let current = parseInt(Cookies.get('len'), 10)
        Cookies.set('len', (current || 0) + 1)
      }

      let cloudFrontTokens = response.data && response.data.video && response.data.video.streamingInfo && response.data.video.streamingInfo.videoAssets && response.data.video.streamingInfo.videoAssets.hlsDetail
      let CloudFrontKeyPairId = ""
      let CloudFrontPolicy = ""
      let CloudFrontSignature = ""
      if(cloudFrontTokens) {
        CloudFrontKeyPairId = cloudFrontTokens.keypairId || ""
        CloudFrontPolicy = cloudFrontTokens.policy || ""
        CloudFrontSignature = cloudFrontTokens.signature || ""
      }
      
      //DRM VIDEOS PLAYBACK HANDLING.
      this.isDrmEnabledVideo=false;
      this.isDrmEnabledVideo = get(response, 'data.video.drmEnabled')
      if(this.isDrmEnabledVideo){
        if(!browser.isSafari() && this.assets.widevine && this.assets.widevine.url){
          return { src: this.assets.widevine.url, type: 'application/dash+xml', licenseUrl: this.assets.widevine.licenseUrl, licenseToken: this.assets.widevine.licenseToken, licensePlayreadyToken: this.assets.playReady && this.assets.playReady.licenseToken, playreadyUrl: this.assets.playReady && this.assets.playReady.url, playReadyLicenseUrl: this.assets.playReady && this.assets.playReady.licenseUrl}
        }else{
          return { src: this.assets.fairPlay.url, type: 'application/x-mpegURL', licenseUrl: this.assets.fairPlay.licenseUrl, licenseToken: this.assets.fairPlay.licenseToken, completeskd: this.assets.fairPlay.completeskd, certificateUrl: this.assets.fairPlay.certificateUrl}
        }
      }

      var hlsAssets = get(this.assets, 'hls')
      let isHdStreaming = !isEmpty(this.state.plans)  ? (this.state.plans[0].featureSetting && this.state.plans[0].featureSetting.isHdStreaming) : true

      let resolutionList = this.assets.mpeg;
      let resolutionListLength = this.assets.mpeg && this.assets.mpeg.length;

      if(!isHdStreaming){
        resolutionList = filter(this.assets.mpeg, function(o) { return (o.renditionValue.slice(1,-1) < 720) });
        resolutionListLength = resolutionList && resolutionList.length;
      }
      
      var mpegAssets = get(resolutionList, `[${resolutionListLength-1}].url`)

      // if appcms is set to hls, try to load hls. Hls may not exist, but mp4 always does.
      // therefore, default to mp4.
      if (this.props.fileType === 'hls' && hlsAssets) {
        if (window.settings.internalName === 'snagfilms' || !hlsAssets.includes("viewlift.com")) {
          if (hlsAssets.includes("hoichoi.tv") || hlsAssets.includes("supercrosslive.tv")) {
            return { src: hlsAssets, type: 'application/x-mpegURL', withCredentials: true, overrideNative: true , CloudFrontKeyPairId: CloudFrontKeyPairId, CloudFrontPolicy: CloudFrontPolicy, CloudFrontSignature: CloudFrontSignature }
          } else if (window.settings.internalName === 'kronon') {
            return { src: hlsAssets, type: 'application/x-mpegURL', handleManifestRedirects: true, CloudFrontKeyPairId: CloudFrontKeyPairId, CloudFrontPolicy: CloudFrontPolicy, CloudFrontSignature: CloudFrontSignature }
          } else {
            return { src: hlsAssets, type: 'application/x-mpegURL', CloudFrontKeyPairId: CloudFrontKeyPairId, CloudFrontPolicy: CloudFrontPolicy, CloudFrontSignature: CloudFrontSignature }
          }
        } else {
          return { src: hlsAssets, type: 'application/x-mpegURL', withCredentials: true, overrideNative: true , CloudFrontKeyPairId: CloudFrontKeyPairId, CloudFrontPolicy: CloudFrontPolicy, CloudFrontSignature: CloudFrontSignature }
        }
      } else {
        return { src: mpegAssets, type: 'video/mp4' }
      }
    }).catch(error =>{
	if(error && error.errorMessage && this.props.embed){
        if(error.errorMessage.includes('Embed not allowed')){
          this.setState({
            embedWall: true
          })
          return 
        }
        if(error.errorMessage.includes('valid subscription')){
          this.setState({
            embedWall: true,
            embedPlayable:true
          })
          return 
        }
      }
      if (error && !error.playable) {
        if(error.errorCode === "CANT_ACCESS_TVE_CONTENT_USER_LOGGED_OUT" && this.state.user && this.state.user.istveLoggedIn){
          userStore.dispatch(refreshTve(false))
        }
        if(this.props.updateEntitlementScreen){
          this.props.updateEntitlementScreen(error.plans)
        }
        this.setState({
          videoWall: true,
          plans: error.plans
        })
        return 
      }
      if(error && error.errorCode && error.errorCode === "MAX_DEVICE_ERROR") {
        Cookies.set('MAX_DEVICE_ERROR',true)
        setTimeout(()=>{
          window.location.href = '/user'
        }, 4000)
        let userDevicesExceedError = getLocalizedVal(window.settings,'genericMessages', 'userDevicesExceedError') || 'User has exceeded the device limit. Go to device management and remove the devices.';
        error = {
          errorMessage : userDevicesExceedError,
          message : userDevicesExceedError
        }
      }
      if (error && error.errorCode && error.errorCode === "VIDEO_NOT_EXISTS"){
        error = {
          errorMessage : getLocalizedVal(window.settings,'genericMessages', 'strContentNotAvailable') || "This content is not currently available.",
        }
      }
      this.setState({errorMessage: (error && error.errorMessage) || (error && error.message)})
      this.errorMessage = this.state && this.state.errorMessage
    })
  }

  async componentDidMount() {
    //Initializing DRM Library for Widevine, DRM, PLayready and Fairplay Video Playback and configuration.
    require('videojs-contrib-dash')
    require('videojs-contrib-eme')
    require('videojs-contrib-quality-levels');
    require('videojs-http-source-selector');
    const { video } = this.props
    let videoFreePlan = null
    if(!this.props.embed && this.props.isEpisode && !this.previewTime && !this.props.isEntitled){
      this.setState({ videoWall: true })
      return
    }
    if(!this.state.user && !this.props.embed){
      if(this.props.isEpisode){
        const episodePlans = video && video.episodePlans
        videoFreePlan = episodePlans && find(episodePlans, function(o){return o.monetizationModel === 'FREE'})
      }else{
        const videoPlans = video && video.plans
        const videoHasFreePlan = videoPlans && find(videoPlans, function(o){return o.type === 'FREE'})
        const videoFreePlanId = videoHasFreePlan && videoHasFreePlan.planIds && videoHasFreePlan.planIds[0]
        const freePlanDetails = videoFreePlanId && await getInvisiblePlansById(videoFreePlanId)
        videoFreePlan = freePlanDetails && freePlanDetails[0]
      }

      if(videoFreePlan){
        let {isEmailRequired, isLoginRequired} = videoFreePlan.featureSetting
        const emailProcessed = localStorage.getItem('emailProcessed')
        if((!this.state.user && isLoginRequired) || (!emailProcessed && isEmailRequired)){
          if(this.props.updateEntitlementScreen && isLoginRequired){
            this.props.updateEntitlementScreen([{...videoFreePlan}])
          }
          this.setState({
            videoWall: true,
            plans: [{...videoFreePlan}]
          })
          return
        }
      }
    }
    this.initializePlayerControls()
  }

  initializePlayerControls = async(assets) => {
    var autoplaySupport;

    let autoplayModule = await import("./ima/autoplay");

    if (window.SERVER_SIDE_RENDERING) {
      //Cannot check autoplay on SSR
      return;
    }

    autoplayModule.getAutoplaySupport().then(
      (result) => {
        autoplaySupport = result;
        if(assets) {
          return assets
        }
        return this.fetchVideoSources((this.props.video.gist.originalObjectId || this.props.videoId))
      }
    ).then(sources => {
      this.setState({ videoAssets: sources })
      const autoplay = (this.props.autoplay && autoplaySupport.autoplayAllowed) || false;
      const mute_sound = get(window, 'settings.features.mute_sound');
      const muted = typeof mute_sound === "boolean" ? mute_sound : autoplaySupport.autoplayRequiresMute;

      let options = {
        controls: true,
        autoplay: autoplay,
        muted: muted,
        preload: true,
        poster: this.state.poster,
        sources: [sources],
        debug: true
      };
      if (this.props.customControls) {
        options.controlBar = this.props.customControls;
      }


      let skin = "./skin";
      if (this.props.customSkin) {
        skin = this.props.customSkin
      }

      import(`${skin}.js`).then(({
        replaceIcons,
        addRewindControl,
        customizeCaptions,
        addResolutionControl,
        addEmbedBtn,
        addSkipControl,
        addVideoTitle,
        addSeasonList
      }) => {
        this.showPinOverlay()
        .then(_ => {
          try{
            this.addResolutionControl = addResolutionControl;
            if(this.isDrmEnabledVideo && !this.state.isLiveStream && sources.type && (sources.type === "application/dash+xml" || sources.type === "application/x-mpegURL")){
              if(isPinSet() && this.state.askPin && (this.props.showPinOverlay || this.state.showPinOverlay)) {
                this.videoRestrictions()
              } else {
                this.initializeDrmPlayer(sources, replaceIcons, addRewindControl, customizeCaptions, addResolutionControl, addEmbedBtn, options);
                if (this.videoNode){
                  configKeyShortcuts(this.player, this.videoNode)
                }
              }
            } else {
              if(isPinSet() && this.state.askPin && (this.props.showPinOverlay || this.state.showPinOverlay)) {
                this.videoRestrictions()
              } else {
                if(sources)
                this.initializePlayer(options, replaceIcons, addRewindControl, customizeCaptions, addResolutionControl, addEmbedBtn, addSkipControl, addVideoTitle, addSeasonList);
                if (this.videoNode){
                  configKeyShortcuts(this.player, this.videoNode)
                }
              }
            }
          } catch(error) {
            console.log(error);
          }
        })

        
      });

    }).catch(error => {
      if (error && !error.playable) {
        this.setState({
          videoWall: true,
          plans: error.plans
        })
        return
      }
      this.setState({ errorMessage: error.errorMessage || error.message })
    })
  }
  initializeDrmPlayer(options, replaceIcons, addRewindControl, customizeCaptions, addResolutionControl, addEmbedBtn, videoOptions){
    let {autoplay,controls,debug,muted,poster,preload}=videoOptions;
    let playObject={autoplay, controls, debug, muted, poster, preload};
    this.player = videojs(this.videoNode, playObject, () => {
      this.addPlayerEntitlementLogic(options, replaceIcons, addRewindControl, customizeCaptions, addResolutionControl, addEmbedBtn);
      this.configureDRMPlayback(options);
    })
    window.player = this.player;
    this.addBeaconObject()
    this.listenToPlayerEvents()
    if(this.shouldAdsInitialize()) {
      this.initializeAds()
    }
  }
  videoRestrictions = async() => {
    if(isPinSet()) {
      await this.setState({ askPin: true });
    } else {
      await this.setState({ askPin: false });
    }
  }
  updatePin() {
    this.setState({ askPin: false });
    this.initializePlayerControls()
  }
  

  initializePlayer(options, replaceIcons, addRewindControl, customizeCaptions, addResolutionControl, addEmbedBtn, addSkipControl, addVideoTitle, addSeasonList) {
      if(options && options.sources[0] && options.sources[0].CloudFrontKeyPairId && options.sources[0].CloudFrontPolicy && options.sources[0].CloudFrontSignature && options.sources[0].type !== "video/mp4") {
        let keypairID = options.sources[0].CloudFrontKeyPairId
        let policy = options.sources[0].CloudFrontPolicy
        let signature = options.sources[0].CloudFrontSignature
        if(browser.isSafari()) {
          videojs.options.hls.overrideNative = true;
          videojs.options.html5.nativeAudioTracks = false;
          videojs.options.html5.nativeVideoTracks = false;
        }
        videojs.Hls.xhr.beforeRequest = (options) => {
          if((options.uri).includes('?')){
            options.uri = `${options.uri}&Key-Pair-Id=${keypairID}&Policy=${policy}&Signature=${signature}`
          } else {
            options.uri = `${options.uri}?Key-Pair-Id=${keypairID}&Policy=${policy}&Signature=${signature}`
          }      
        }
      } 
    if(this.state.video && this.state.video.liveDetails && this.state.video.liveDetails.isLowLatency) {
      window.registerIVSTech(videojs)
      options["techOrder"] = ["AmazonIVS"]
    }
    this.player = videojs(this.videoNode, options, () => {
      this.addPlayerEntitlementLogic(options, replaceIcons, addRewindControl, customizeCaptions, addResolutionControl, addEmbedBtn, addSkipControl, addVideoTitle, addSeasonList);
    })
    window.player = this.player;
    if(this.state.video && this.state.video.liveDetails && this.state.video.liveDetails.isLowLatency) {
      window.player.src(options.sources[0].src)
    }
    this.addBeaconObject()
    //bubbling player refernce to parent component
    this.props.getVideoRef && this.props.getVideoRef(this.player);
    this.listenToPlayerEvents()
    if(this.shouldAdsInitialize()) {
      this.initializeAds()
    }
  }

  videoPersonalizationHandler = ()=>{
    if(this.props.isFree){
      ///// VIEWLIFT-3000 -- As Per QA Comments in this Ticket ////////
      if(this.state.user && Cookies.get('isUserSignUp') && Cookies.get('isUserSignUp').match('true') && window.settings.recommendation && window.settings.recommendation.isPersonalization && window.settings.recommendation.recommendCategories && window.settings.recommendation.recommendCategories.length>0){
        if(!window.settings.recommendation.isSubscribed){
          persolizationSetUpProfile() && Cookies.set('isUserSignUp', false) &&  Cookies.set('isThankYouPage', false);
          setTimeout(()=>{
            window.player.pause();
          }, 200)
        }
      }
    }
  }

  setCCSettings = () => {
    let buttons = document.querySelectorAll('.vjs-subs-caps-button li.vjs-menu-item');
    buttons.forEach((btn) =>{
      btn.addEventListener('click', function(e) {
        if(!e.currentTarget.classList.contains('vjs-texttrack-settings')) {
          if(e.currentTarget.classList.contains('vjs-selected') && e.currentTarget.classList.contains('vjs-subtitles-menu-item')){
            localStorage.setItem('ccDefault', 'on');
            localStorage.setItem('ccDefaultLang', (e.currentTarget).querySelector('.vjs-menu-item-text').innerHTML);
          } else {
            localStorage.setItem('ccDefault', 'off');
          }
        }
      })
    })
  }

  addPlayerEntitlementLogic = (options, replaceIcons, addRewindControl, customizeCaptions, addResolutionControl, addEmbedBtn, addSkipControl, addVideoTitle, addSeasonList) =>{
      replaceIcons(this.player)
      addSkipControl && addSkipControl(this.player)
      addVideoTitle && addVideoTitle(this.player, this.props.video);
      addSeasonList && addSeasonList(this.player, this.props.video);
      addRewindControl(this.player)
      let captions = this.props.closedCaptions || get(this.state, 'video.contentDetails.closedCaptions')
      let userProgress = parseInt(Cookies.get('hdbm')) 
      let videoPreviewSettings = get(window.settings, 'features.free_preview')
      let perVideoFlag = videoPreviewSettings && videoPreviewSettings.per_video
      if (some(captions, { format: 'VTT' }))
        customizeCaptions(this.player)

      let isHdStreaming = !isEmpty(this.state.plans) ? (this.state.plans[0].featureSetting && this.state.plans[0].featureSetting.isHdStreaming) : true

      addResolutionControl(this.player, this.isDrmEnabledVideo? "drm" : this.props.fileType, this.assets, this.state.isLiveStream, this.showUpgradePopup, isHdStreaming)

      let isEmbedEnabled = window.settings.embedPlayer && window.settings.embedPlayer.showEmbedButton
      isEmbedEnabled  && addEmbedBtn(this.player, this.toggleEmbed);
      this.props.showTimer && this.appendRemainingContainer(this.player, this.props.showTimer)
      if (this.props.autoplay && !browser.isMobile() && !browser.isSafari()) {
        this.startVideo()
      }
  }

  addBeaconObject = (newProps)=>{
    let dataSource = this.props
    if(newProps) {
      dataSource = newProps
    }
    const { video } = dataSource
    var beacon = {}
    beacon = new VideoJSBeacon({
      player: this.player,
      videoTitle: get(dataSource, 'video.gist.title'),
      videoId: dataSource.videoId,
      seriesTitle: get(dataSource, 'seriesInfo.title'),
      seriesId: get(dataSource, 'seriesInfo.id'),
      ...(video && {
        contentCategory: get(video.gist, 'primaryCategory.title'),
        isLiveStream: get(video.gist, 'isLiveStream')
      }),
      fileType: dataSource.fileType,
      assets: this.assets,
      siteName: window.settings.internalName,
      clientId: window.settings.siteId,
      platform: 'WEBSITE',
      userId: dataSource.user && dataSource.user.userId,
      apiUrl: window.settings.beacon.apiBaseUrl,
      environment: getEnvironment()
    })
    this.beacon = beacon
  }

  shouldAdsInitialize = () =>{
    if(this.state.dfpTag){
      const isTransactional = this.state.plans && this.state.plans[0].monetizationModel === 'TVOD';
      const {transactionPurchased, subscribed, loggedIn, nonLoggedIn, churned} = this.state.adFeatures
      let includeAds = this.state.user && (this.state.user.isSubscribed || isTransactional) && this.state.plans && this.state.plans[0].featureSetting && this.state.plans[0].featureSetting.includingAds !== undefined ? this.state.plans[0].featureSetting.includingAds : true //svod tvod plan ads include check
      let showAdsTo = (this.state.user && ((this.state.user.isSubscribed && subscribed) || (loggedIn && !this.state.user.isSubscribed && !isTransactional) ||  ((this.state.user.subscriptionStatus === 'SUSPENDED' || this.state.user.subscriptionStatus === 'CANCELLED') && churned) || (isTransactional && transactionPurchased))) || (!this.state.user && nonLoggedIn); //avod plan feature check
      return ((typeof (window.google) !== 'undefined') && includeAds && showAdsTo)
    }
    return false
  }
  
  appendRemainingContainer(player, container) {
    player.el_.append(container)
  }

  getRemainingTime(time) {
    let minutes = Math.floor(time / 60)
    let seconds = Math.floor(time - minutes * 60)
    const wrapper = document.querySelector('.remaining-time-wrapper')
    wrapper && (wrapper.style.visibility = 'visible')
    const remainingTimeContainer = document.querySelector('.time-elapsed')
    remainingTimeContainer && (remainingTimeContainer.innerHTML = `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`)
  }

  toggleEmbed() {
    this.setState({
      showEmbed: !(this.state.showEmbed)
    })
  }

  showUpgradePopup() {
    this.setState({
      showUpgrade: !(this.state.showUpgrade)
    })
  }

  checkIfVideoIsFree() {
    if(this.props.embed)
      return true

    const priceType = this.props.pricingOptions ? this.props.pricingOptions.type : null;

    const videoIsFree = this.state.isFree;
    const videoPriceOptionSimilarToFree = priceType === "FREE" || priceType === "AVOD" || priceType === null;

    return videoIsFree || videoPriceOptionSimilarToFree
  }

  checkIfVideoIsEntitled= () => {
    const { video } = this.props
    let isVideoEntitled = video && checkVideoContentEntitlement(video, this.state.plans)
    return isVideoEntitled
  }

  onTimeUpdate = (ref, pingTimes, playedTime)=>{
    pingTimes = [];
    playedTime = [];
    var time = Math.floor(ref.player.currentTime())
    ref.props.showTimer && ref.getRemainingTime(
      ref.props.isLive ? (ref.props.scheduleEndDate - Date.now()) / 1000 :
        ref.player.remainingTimeDisplay()
    )
    if (!includes(playedTime, time)) {
      playedTime.push(time)
      ref.sendWatchedEventData(time, ref.player.duration())
      if((ref.perVideo && (ref.props.videoId !== Cookies.get('videoId'))) || (ref.props.user && ref.props.user.isSubscribed)) {
        Cookies.set('hdbm', 0);
      }
      let userProgress = parseInt(Cookies.get('hdbm')) || time
      if ((ref.previewshowUnit !== 'Videos') && ref.previewTime && (userProgress <= ref.previewTime)) { 
        if(ref.perVideo ) {
          Cookies.set('hdbm', time)
          time = userProgress
        } else if(!this.perVideo) {
          Cookies.set('hdbm', userProgress + 1)
          time = userProgress
        }
      } 

      if(!this.props.embed && (ref.previewTime && (userProgress >= ref.previewTime) && ((ref.props.isEpisode && !ref.props.isEntitled) || (!ref.props.isEpisode && !ref.checkIfVideoIsEntitled()))) ){
        ref.setState({ videoWall: true });
        ref.player.pause();
        if(!ref.props.overlay) {
          ref.player.dispose();
        }  
        ref.props.updateEntitlementScreen(this.state.plans)
      }
      if(ref.perVideo) {
        Cookies.set('videoId', ref.props.videoId)
      }
      if (ref.previewshowUnit === 'Videos' && !ref.state.isFree) {
        time = parseInt(Cookies.get('len'))
      }
      let watchedInterval = (window.settings.features && window.settings.features.watched_history && window.settings.features.watched_history.interval && parseInt(window.settings.features.watched_history.interval)) || 90
      let enableWatchedHistory = (window.settings.features && window.settings.features.watched_history && window.settings.features.watched_history.enable) || false
      if (watchedInterval !== 0 && enableWatchedHistory && time >= watchedInterval &&
        time % watchedInterval === 0 &&
        ref.props.user &&
        !includes(pingTimes, time) &&
        !ref.props.isTrailer && !ref.props.isPromo && isFinite(ref.player.duration())) {
        pingTimes.push(time)
        var duration = Math.floor(ref.player.duration())
        ref.sendWatchedInfo(time, duration).then((response) => {
          if(response && response.error && response.error === "MAX_STREAMS_ERROR") {
            this.setState({errorMessage: response.errorMessage || "User has exceeded the concurrent stream limit"})
          }
        }).catch((error) => {
          console.log(error)
        })
      }
      var videoDuration = Math.floor(ref.player.duration())
      if(!includes(pingTimes, time) &&
      enableWatchedHistory &&
      !ref.props.isTrailer &&
      !ref.props.isPromo &&
      isFinite(ref.player.duration()) && 
      ref.props.user &&
      (parseInt(videoDuration) - parseInt(time)) < 5  ) {
        if(!ref.resetHistory) {
          ref.sendWatchedInfo(time, videoDuration,true).then((response) => {
            if(response && response.error && response.error === "MAX_STREAMS_ERROR") {
              this.setState({errorMessage: response.errorMessage || "User has exceeded the concurrent stream limit"})
            }
          }).catch((error) => {
            console.log(error)
          })
        }
      }
    }
  }

  listenToPlayerEvents() {
    var ref = this;
    this.player.one(browser.isMobile() ? 'touchend' : 'click', _ => {
      // if (browser.isMobile() || browser.isSafari() || !this.state.ratingDisplayDone || !this.props.autoplay)
      this.startVideo()
    })

    this.player.one('loadeddata', () => {
      const runtime = get(this.state.video, "gist.runtime");
      if (!isFinite(this.player.duration()) && !isFinite(runtime)) {
        document.getElementsByClassName('VideoJS')[0].classList.add('live')
      }
      if(this.isFromErrorEvent){
        this.isFromErrorEvent=false;
        return;
      }
      if (this.props.startTime) {
        this.player.currentTime(this.props.startTime)
      }
    })

    this.player.on('firstplay', (e) => {
      if (!this.playStarted && this.state.video) {
        var { gist = {}, creditBlocks = [], categories = [] , parentalRating = 'NA' } = this.state.video
        categories.push(gist.primaryCategory || {})
        const contentTypeDetail = window.location.pathname.match(/movies|kids|originals|shows/g) || ['videos']

      this.playData =  {
        contentTypeDetail: contentTypeDetail[0],
        freeOrPaid: gist.isFree ? "Free" : (gist.free ? "Free" : "Paid"),
        rating: parentalRating
      }

        this.videoEventData = {
          contentId: gist.id,
          contentTitle: gist.title,
          contentType: gist.isTrailer ? 'Trailer' : gist.mediaType === 'EPISODIC' ? 'Episode' : 'Video',
          contentDuration: gist.runtime,
          playbackType: 'Streamed'
        }
        if (gist.mediaType === 'EPISODIC' && this.props.video && this.props.video.showData) {
          creditBlocks = this.props.video.showData.creditBlocks
          categories = this.props.video.showData.categories
          categories.push(this.props.video.showData.gist.primaryCategory || {})
          this.videoEventData = extend({}, this.videoEventData, {
            episodeNumber: this.props.video.currentEpisode + 1,
            seasonNumber: this.props.video.currentSeason + 1,
            showName: this.props.video.showData.gist.title
          })
        }
        this.videoEventData.playSource = getPlaySourcePrefix() + (this.props.video && this.props.video.showData ? '_Show Detail' : '_Video Detail')
        each(creditBlocks, creditBlock => {
          if (creditBlock.title.trim().toLowerCase() === 'director')
            this.videoEventData.directorName = creditBlock.credits && creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
          if (creditBlock.title.trim().toLowerCase() === 'starring')
            this.videoEventData.actorName = creditBlock.credits && creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
        })
        this.videoEventData.contentGenre = categories.map(category => category.title).join(',')
        trackEvent('Play Started', extend({}, this.videoEventData, this.playData))
        this.playStarted = true
      }
    })

    var pingTimes = [], playedTime = []
    this.player.on('timeupdate', event => {
      this.onTimeUpdate(ref, pingTimes, playedTime);
    })
    this.player.on("pause", function () {
      ref.triggeredPause = true
    });
    
    this.player.on("play", function () {
      if(ref.triggeredPause === true) {
        let isEmbed = ref.props.embed === undefined ? false : ref.props.embed;
         getVideoEmbed(ref.props.videoId, isEmbed, response => {
          }).catch(error =>{
          ref.setState({errorMessage: error && (error.errorMessage || error.message)})
          ref.errorMessage = ref.state && ref.state.errorMessage
        })
      }
      ref.triggeredPause = false  
    });

    this.player.on('waiting', event => {
      this.bufferCount += 1
      const offset = 0.1
      let lastVideoPosition = this.player.currentTime()
      let updatedPingTimes = []
      let watchedInterval = (window.settings.features && window.settings.features.watched_history && window.settings.features.watched_history.interval && parseInt(window.settings.features.watched_history.interval)) || 0
      let enableWatchedHistory = (window.settings.features && window.settings.features.watched_history && window.settings.features.watched_history.enable) || false
      if (watchedInterval !== 0 && enableWatchedHistory && lastVideoPosition >= watchedInterval &&
        lastVideoPosition % watchedInterval === 0 &&
        ref.props.user &&
        !includes(updatedPingTimes, lastVideoPosition) &&
        !this.props.isTrailer && isFinite(this.player.duration())) {
          updatedPingTimes.push(lastVideoPosition)
        var duration = Math.floor(this.player.duration())
        this.sendWatchedInfo(lastVideoPosition, duration)
        .then((response) => {
          if(response && response.error && response.error === "MAX_STREAMS_ERROR") {
            this.setState({errorMessage: response.errorMessage || "User has exceeded the concurrent stream limit"})
          }
        })
        .catch((error) => {
          console.log(error)
        })
      }
      var videoDuration = Math.floor(this.player.duration())
      if(!includes(updatedPingTimes, lastVideoPosition) &&
      enableWatchedHistory &&
      ref.props.user &&
      !this.props.isTrailer && !ref.props.isPromo && isFinite(this.player.duration()) && 
      (parseInt(videoDuration) - parseInt(lastVideoPosition)) < 5  ) {
        if(!ref.resetHistory) {
          this.sendWatchedInfo(lastVideoPosition, videoDuration, true)
          .then((response) => {
            if(response && response.error && response.error === "MAX_STREAMS_ERROR") {
              this.setState({errorMessage: response.errorMessage || "User has exceeded the concurrent stream limit"})
            }
          })
          .catch((error) => {
            console.log(error)
          })
        }
      }

      let bufferingTimer = setInterval(() => {
        try{
          if (
            (this.player && this.player.currentTime() <= (lastVideoPosition + offset)) && !this.player.paused()) {
            this.totalBufferTime = this.totalBufferTime + 0.1
          } else {
            clearInterval(bufferingTimer)
          }
        }catch(e){
          clearInterval(bufferingTimer)
        }
      }, 100)
    })

    this.player.on('ended', event => {      

      if (!window.settings.features['auto_play'])
        return

      if (this.props.isPlaylistItem)
        this.setState({ videoEnded: true })

      if (this.props.isEpisode && this.props.video.nextEpisode)
        this.setState({ videoEnded: true })

      let relatedVideos = get(this.props, 'video.contentDetails.relatedVideoIds')
      
      //In Case Recommendation AutoPlay is on need to play recommended Videos
      if(window.settings && window.settings.recommendation && window.settings.recommendation.isRecommendation && window.settings.recommendation.isRecommendationAutoPlay && Cookies.get('isFromRecommendationTray') && Cookies.get('isFromRecommendationTray')=="true") {
        if(localStorage.getItem("recommendedVideoIds") && JSON.parse(localStorage.getItem("recommendedVideoIds")).records && JSON.parse(localStorage.getItem("recommendedVideoIds")).records.length>0){
          relatedVideos=(JSON.parse(localStorage.getItem("recommendedVideoIds")).records)
            .filter((elem,position)=> {
                if((elem.gist.mediaType && elem["gist"]["mediaType"].toLowerCase() !== "series") || (elem.gist.contentType && elem["gist"]["contentType"].toLowerCase() !== "series"))
                  return (elem.gist && elem.gist.id!=null);
            })
            .map((element,position)=> element.gist.id)

          if (!relatedVideos || relatedVideos.length === 0)
            return

          let currentVideoId = get(this.props, 'video.gist.id')
          let currentPosition=0;
          let currentVideoPosition = relatedVideos.find((element, position)=>{
            currentPosition = position;
            return element === currentVideoId;
          })

          if(currentVideoPosition === undefined)
            return
          if(currentPosition >= relatedVideos.length)
            return;

          getVideo(relatedVideos[currentPosition+1], response => {
            window.location.href = response.data.video.gist.permalink
          })
          return;
        }
      }

      if (!relatedVideos || relatedVideos.length === 0){
        if(this.isDrmEnabledVideo){
          this.fetchVideoSources((this.props.video.gist.originalObjectId || this.props.videoId)).then((videoAssets) => {
            videoAssets["isFromVideoEnded"]=true;
            this.configureDRMPlayback(videoAssets);
          })
        }  
        return;
      }

      if (this.props.isEpisode)
        return
      if (this.props.isPlaylistItem)
        return

      // check for RTA only
      if (this.props.isNewsTrailer)
        return

      let current = window.sessionStorage.getItem('rvid') !== null
        ? parseInt(window.sessionStorage.getItem('rvid'), 10) + 1
        : 0
      
      window.sessionStorage.setItem('rvid', current)
      getVideo(relatedVideos[current], response => {
        window.location.href = response.data.video.gist.permalink
      })
      
    })

    this.player.on('error', event => {
      var playErrorEventData = {}
      if (this.videoEventData) {
        assignIn(playErrorEventData, this.videoEventData)
      }
      playErrorEventData.errorMessage = this.player.error().message;
      trackEvent('Media Error', playErrorEventData);
      // reset player to prevent chrome from crashing on erroneous live stream
      let playerUpdatedTime=Math.floor(this.player.currentTime());
      if((this.player.error().code === 5)) {
        if(this.isDrmEnabledVideo){
          if(browser.isSafari()){
          this.isFromErrorEvent=true;
          this.fetchVideoSources((this.props.video.gist.originalObjectId || this.props.videoId)).then((videoAssets) => {
              videoAssets["certificateUrl"]=`https://v-${window.settings.internalName}.viewlift.com/fairplay.cer`
              this.configureDRMPlayback(videoAssets);
              this.player.load();
              this.player.currentTime(playerUpdatedTime);
              this.player.play();
            })
          }else{
            this.isFromErrorEvent=true;
            this.fetchVideoSources(this.props.videoId).then((videoAssets) => {
              this.configureDRMPlayback(videoAssets);
              this.player.load();
              this.player.currentTime(playerUpdatedTime);
              this.player.play();
            })
          }
        }
      }

      // reset player to prevent chrome from crashing on erroneous live stream
      if((this.player.error().code === 3 || this.player.error().code === -3) && (this.props.video && this.props.video.gist.isLiveStream)) {
        this.fetchVideoSources((this.props.video.gist.originalObjectId || this.props.video.gist.id)).then((videoAssets) => {
          this.player.reset()
          this.player.src(videoAssets.src)
          this.player.load()
        })
      }

      // handle playback error for error code 4 and 2
      if(this.player.error().code === 2){
        this.fetchVideoSources(this.props.video.gist.id).then((videoAssets) => {
          this.player.reset()
          this.player.src(videoAssets.src)
          this.player.load()
          this.player.play()
        })
      }
    })

    this.player.on('ready', event => {
      let captions = filter(this.props.closedCaptions || get(this.state, 'video.contentDetails.closedCaptions'), { format: 'VTT' });
      this.updateCaptions(captions, this.currentModeValue);
      this.videoPersonalizationHandler();
    });

    this.player.on('ended', event => {
      this.props.videoEndedHandler && this.props.videoEndedHandler();
    });
  }

  refreshPlayer() {
    if (this.player.currentTime() === this.bufferedPercent) {
      this.bufferedPercent++;
      this.player.currentTime(this.bufferedPercent)
    } else {
      clearInterval(this.refresh)
    }
  }

  sendWatchedInfo(time, duration, reset) {
    var ref = this
    ref.resetHistory = reset
    if((!this.initialData.videoId || (this.initialData.videoId === this.props.videoId)) && this.initialData.watchedTime !== time) {
      this.initialData.videoId = this.props.videoId
      this.initialData.watchedTime = time
      return saveWatchHistory({
        videoId: this.props.videoId,
        watchedTime: time,
        watchedPercentage: Math.floor((time / duration) * 100),
        siteOwner: window.settings.internalName,
        userId: this.props.user && this.props.user.userId
      }).then((response) => {
        return response
      }).catch(error =>{    
        console.log(error)
        return error
      })
    }
  }

  sendWatchedEventData(time, duration) {
    if (this.videoEventData) {
      var pushWatchedEvent = false
      var streamedPercent = Math.floor((time / duration) * 100)
      var watchedEventData = extend({}, this.videoEventData, this.playData)
      if (time >= 120 && streamedPercent < 25 && this.streamedData.indexOf('2 mins') === -1) {
        this.streamedData.push('2 mins')
        pushWatchedEvent = true
      } else if (streamedPercent >= 25 && streamedPercent < 50 && this.streamedData.indexOf(25) === -1) {
        this.streamedData.push(25)
        pushWatchedEvent = true
      } else if (streamedPercent >= 50 && streamedPercent < 75 && this.streamedData.indexOf(50) === -1) {
        this.streamedData.push(50)
        pushWatchedEvent = true
      } else if (streamedPercent >= 75 && streamedPercent < 80 && this.streamedData.indexOf(75) === -1) {
        this.streamedData.push(75)
        pushWatchedEvent = true
      } else if (streamedPercent >= 80 && this.streamedData.indexOf(80) === -1) {
        this.streamedData.push(80)
        pushWatchedEvent = true
      }
      if (pushWatchedEvent) {

        let showNameVal = '';
        if(this.props.video && get(this.props.video, 'showData.gist.title')) {
          showNameVal = this.props.video.showData.gist.title;
        }

        var captions = filter(this.props.closedCaptions || get(this.state, 'video.contentDetails.closedCaptions'), { format: 'VTT' })
        watchedEventData.subtitles = captions.length ? 'Y' : 'N'
        watchedEventData.stream = this.streamedData[this.streamedData.length - 1]
        watchedEventData.bufferTime = round(this.totalBufferTime)
        watchedEventData.bufferCount = this.bufferCount
        watchedEventData.watchedTime = round(time - this.lastBufferedTime)
        watchedEventData.bitRate = this.beacon.getBitrate();
        watchedEventData.seasonNumber = this.props.video && this.props.video.currentSeason ||"";
        watchedEventData.episodeNumber = this.props.video && this.props.video.currentEpisode || "";
        watchedEventData.showName = showNameVal;
        watchedEventData.platform = 'Web';
        watchedEventData.networkType = window.navigator.connection ? (window.navigator.connection.type ? window.navigator.connection.type : window.navigator.connection.effectiveType) : "wifi";
        
        trackEvent('Watched', watchedEventData)
        this.lastBufferedTime = time
        this.totalBufferTime = 0
        this.bufferCount = 0
      }
    }
  }

  startVideo() {
    var showAds =
      (this.props.videoTag !== undefined) &&
      !this.props.hideAds

    if (this.shouldAdsInitialize()) {
      this.player.ima.initializeAdDisplayContainer && this.player.ima.initializeAdDisplayContainer()
      //this.toggleRatingDiscretion()
      this.listenToAdEvents()
      return
    }

    this.toggleRatingDiscretion()
  }

  initializeAds() {
    let videoTag = this.state.dfpTag || this.props.videoTag;;
    const adProvider = videoTag.includes('spotx') ? 'spotx' : 'google';
    this.adUrl = null;
    if(adProvider === 'google'){

      let custParamsIndex = videoTag.indexOf('cust_params='); 
      let adTagUrl = new URL(videoTag);
      let query_string = adTagUrl.search;
      let search_params = new URLSearchParams(query_string); 

      if(custParamsIndex >= 0) {
        search_params.set('description_url', window.location)
        search_params.set('vid', this.props.videoId)
        search_params.set('correlator', new Date().getTime())
      }else{
        search_params.set('description_url', window.location)
        search_params.set('vid', this.props.videoId)
        search_params.set('url', window.location.href)
        search_params.set('correlator', new Date().getTime())
        search_params.set('cust_params=sd', 60000)
        search_params.append('vid', this.props.videoId)
      }

      search_params.append('site', window.location.origin)
      search_params.append('autostart', '')
      search_params.append('mute', '')
      search_params.append('user_agent', '')
      search_params.append('keyword', '')
      search_params.append('category', this.props.category)
      search_params.append('categories', this.categories)
      search_params.append('tags', this.tags)

      adTagUrl.search = search_params.toString();
      let updated_tag_url = adTagUrl.toString();
      this.adUrl = updated_tag_url
    }else if(adProvider === 'spotx'){
      let adTagUrl = new URL(this.props.videoTag);
      let query_string = adTagUrl.search;
      let search_params = new URLSearchParams(query_string); 
      search_params.set('content_page_url', window.location.href);
      search_params.set('player_width', this.player.el_.clientWidth);
      search_params.set('player_height', this.player.el_.clientHeight);
      search_params.set('user[consent]', true);
      search_params.set('regs[gdpr]', true);
      search_params.set('cb', (new Date()).getTime().toString());
      adTagUrl.search = search_params.toString();
      let updated_tag_url = adTagUrl.toString();
      this.adUrl = updated_tag_url
    }

    this.player.ima({
      id: 'vjs_video_3',
      adTagUrl: this.adUrl,
      adLabel: 'Your video will resume after this sponsor message'
    })
  }

  listenToAdEvents() {
    this.player.on("adsready", () => {
      window.player.ima.getAdsManager().addEventListener(window.google.ima.AdEvent.Type.COMPLETE, () => {this.toggleRatingDiscretion()})
      window.player.ima.getAdsManager().addEventListener(window.google.ima.AdEvent.Type.AD_ERROR, () => {this.toggleRatingDiscretion()})
     });
    
  }

  toggleRatingDiscretion() {
    if (this.isRatingEnabled() && !this.state.ratingDisplayDone) {
      return this.showRatingDiscretion()
    }
    return this.hideRatingDiscretion()
  }
  componentWillUnmount() {
    try{
      if (this.player) {
        this.player.dispose()
      }
    }catch(e){}
  }

  componentDidUpdate(prevProps, prevState) {
    // pause video if trailer modal is open
    if (!prevProps.modalOpen && this.props.modalOpen) {
      if (this.player && this.player.player_) {
        this.player.pause()
      } else {
        return
      }

      if (typeof (window.google) !== "undefined" && this.player && this.player.ima) {
        isFunction(this.player.ima.pause) && this.player.ima.pause()
      }
    } else if (prevProps.modalOpen && !this.props.modalOpen) {
      // this.player.play()
      if (typeof (window.google) !== "undefined" && this.player)
        isFunction(this.player.ima.resume) && this.player.ima.resume()
    }
    if (this.player && !this.state.startedAtSetTime && this.props.startTime) {
      this.player.currentTime(this.props.startTime)
      this.setState({ startedAtSetTime: true })
    }
    if (!prevState.showEmbed && this.state.showEmbed) {
      this.player.pause()
    }
  }

  isRatingEnabled() {
    return (
      (get(window.settings, 'user_content_rating', false)) &&
      !this.props.isTrailer &&
      this.parentalRating &&
      this.parentalRating !== 'NR'
    )
  }

  hideRatingDiscretion() {
    this.player.play()
    this.setState({
      showRatingDiscretion: false,
      ratingDisplayDone: true
    })
  }

  showRatingDiscretion() {
    this.player.pause()
    this.setState({ showRatingDiscretion: true })
  }


  updateCaptions(captions, currentMode) {
    const isCCOn = (localStorage.getItem('ccDefault') === 'on');
    const ccLang = localStorage.getItem('ccDefaultLang')
    if (this.player && captions) {
      map(this.player.remoteTextTrackEls(), (capEl) => {
        this.player.removeRemoteTextTrack(capEl)
      })
      map(captions, (caption) => {
        this.player.addRemoteTextTrack({
          src: caption.url,
          manualCleanup: true,
          srcLang: caption.language,
          label: caption.language
        }, true)
      })
      if((currentMode || isCCOn) && this.player.textTracks() && this.player.textTracks().tracks_.length > 0) {
        var findCurrentModePlayer = this.player.textTracks().tracks_.find((element)=>{
          if((isCCOn && element.label === ccLang)){
            return element;
          } else {
            return null
          }
        })
        if(findCurrentModePlayer) 
          findCurrentModePlayer.mode = "showing";
      }
    }
    this.setCCSettings();
  }

  get parentalRating() {
    return this.props.parentalRating || get(this.props, 'video.parentalRating')
  }

  initializeOverlayPlayer = () => {
    if(this.state.initializePlayer) {
      this.player.reset()
      let videoAssets = this.state.videoAssets
      const src = videoAssets && videoAssets.src;
      if(this.isDrmEnabledVideo){
        this.configureDRMPlayback(videoAssets)
      }else{
        this.player.src(src)      
        this.player.load()
        this.player.play()
      }
    } 
  }

  //DRM VIDEOS FUNCTIONALIY FUNCTIONS START
  configureDRMPlayback = (options) => {
    if(!browser.isSafari()){
      // this.player.eme();
      this.player.src(getDRMWidevinePlayreadyObject(options));
      if(!options["isFromVideoEnded"])
        this.player.play();
      else
        this.player.pause();
    }else{
      var fairObject = getFairPlayObject(options, videojs);
      try{
        this.player.eme();
      }catch(e){}
      this.player.src(fairObject);
      if(!options["isFromVideoEnded"])
        this.player.play();
    }
  }
  //DRM VIDEOS FUNCTIONALIY FUNCTIONS END


  playVideoCb() {
    this.setState({videoWall:false})
    this.initializePlayerControls()
  }

  render() {
    return (
      <div>
        {this.state.videoEnded && !this.props.disableNextEpisodeTimer &&
          <NextVideoTimer
            backgroundUrl={this.props.video.nextEpisode.videoImageUrl}
            nextVideoTitle={this.props.video.nextEpisode.title}
            timer={3}
            action={this.props.video.playNextEpisode}
          />
        }
        {this.state.videoEnded && !this.props.disableNextEpisodeTimer && this.props.isPlaylistItem && this.props.nextVideoDataAction.nextVideoData.gist &&
          <NextVideoTimer
            backgroundUrl={this.props.nextVideoDataAction.nextVideoData.gist.videoImageUrl}
            nextVideoTitle={this.props.nextVideoDataAction.nextVideoData.gist.title}
            timer={3}
            isPlaylistItem={this.props.isPlaylistItem}
            action={this.props.nextVideoDataAction.playNextAction}
          />
        }
        {this.state.videoWall &&
          <WaysToWatch
            isEpisode={this.props.isEpisode}
            content={this.props.video}
            videoGist={this.props.video && this.props.video.gist}
            plans={this.state.plans}
            cb={() => this.playVideoCb()}
            metadataMap={get(this, 'props.metadataMap') || {}}
          />
        }
        {this.state.embedWall &&
          <EmbedWall
            isEpisode={this.props.isEpisode}
            content={this.props.video}
            embedPlayable={this.state.embedPlayable}
            videoGist={this.props.video && this.props.video.gist}
          />
        }
        { isPinSet() && this.state.askPin && (this.props.showPinOverlay || this.state.showPinOverlay) &&
          <PinOverlay videoId={this.props.videoId} askPin={this.state.askPin} initializePlayer={() => this.initializeOverlayPlayer()} changePinState={() => this.updatePin()} />
        }
        {this.state.showUpgrade && <Upgrade toggleUpgrade={this.showUpgradePopup} />}

        <div data-vjs-player>
          {this.state.showRatingDiscretion &&
            <RatingDiscretion
              hide={this.hideRatingDiscretion.bind(this)}
              rating={this.parentalRating} />
          }
          {this.state.showEmbed && <Embed videoId={this.props.videoId} toggleEmbed={this.toggleEmbed} />}
          {this.state.errorMessage
            ? <div className="error-message"> {this.state.errorMessage} </div>
            : <video
              ref={node => this.videoNode = node}
              playsInline
              id="videoplayer"
              className={`video-js` + (this.hasAccess || this.props.isFree ? '' : ' hd-cc')}
            >
            </video>
          }
        </div>
      </div>
    )
  }
}
connect(VideoJS, state => ({ user: state.user }), userStore)
export default VideoJS